export default __webpack_public_path__ + "2a76398bf65a5a590b28833efdcb82e3.svg";